import { useState } from "react";
import { json } from "stream/consumers";
import { CSVLink, CSVDownload } from "react-csv";
import { MainConfig } from "../configs/mainConfig";
import { useNavigate } from "react-router-dom";
import '../styles/HomePage.scss'


export const DataExporter = () =>{
    let navigate = useNavigate();
    const [files, setFiles] = useState("");

    const [dateValue, setDateValue] = useState(null);
    const [userIDValue, setUserID] = useState<string>("");
    const [loading, setLoading] = useState<boolean>(false);
    const [csvReport, setCsvReport] = useState<any>()


    const handleDateUpdate = (e:any) => {
        e.target.classList.remove("invalid");
        setDateValue(e.target.value);
    }

    const handleUserIDUpdate = (e:any) => {
        e.target.classList.remove("invalid");
        setUserID(e.target.value);
    }
    const redirectHome = (e:any) => {
        navigate("/")
    }
    

    const handleExportButtonClick = () => {
        let dateInput : HTMLInputElement | null = document.getElementById("dateInput") as HTMLInputElement;
        if(dateValue == null || !dateInput.checkValidity()){
            dateInput.classList.add("invalid");
            return;
        }
        else{
            dateInput.classList.remove("invalid");
        }

        setLoading(true);

        let date = dateValue + "T00:00:00"
        let userID = userIDValue?.toLocaleLowerCase()
        let urlAPI = `${MainConfig.backendEndpoint}/api/forms/FormData/${date}/${userID}`;
        fetch(`${MainConfig.backendEndpoint}/connect/token`, {
            method: 'POST',
            body: 'grant_type=client_credentials&client_id=' + MainConfig.apiKey + '&client_secret=' + MainConfig.apiSecret + '&scope: K2Forms',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        }).then(function (resp) {

            // Return the response as JSON
            return resp.json();
        
        }).then(function (data) {
        
            // Log the API data
            console.log('token', data);
            return fetch(urlAPI, {
                headers: {
                    'Authorization': data.token_type + ' ' + data.access_token,
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            });
        
        }).then(function (resp) {

            // Return the API response as JSON
            return resp.json();
        
        }).then(function (data) {
        
            // Log the pet data
            console.log('file', data);
            processingJson(data);
            setLoading(false);
        }).catch(function (err) {
            setLoading(false);
            // Log any errors
            console.log('something went wrong', err);
        
        });
    }


    const processingJson = (json : any) => {
        //Excel file   

        //Headers
        const headers = [
            { label: "Libelle", key: "name" },
            { label: "Réponse", key: "data" },
        ];

        //Data
        let data : Array<any> = [];
        let lastKey : string = Object.keys(json)[Object.keys(json).length-1]
        
        let jsonUserData = json[lastKey];
        //Various data
        let userId = jsonUserData.user;
        if(!jsonUserData.User){
            return;
        }
        
        //Données User
        let Societe = jsonUserData.User?.Company;
        let Email = jsonUserData.User?.Mail;
        
        let Relation = {
            "Prenom" : jsonUserData.User?.Relation?.Prenom,
            "Sexe" : jsonUserData.User?.Relation?.Sexe,
            "Reponse" : jsonUserData.User?.Relation?.Reponse,
            "Emotion" : jsonUserData.User?.Relation?.Emotion,
            "Reaction" : jsonUserData.User?.Relation?.Reaction,
            "Besoin" : jsonUserData.User?.Relation?.Besoin,
            "EmotionEngendre" : jsonUserData.User?.Relation?.EmotionEngendre,
            "RepriseScenario" : jsonUserData.User?.Relation?.RepriseScenario

        }
        
        let Besoin = jsonUserData.User?.Besoin
        let CauseEmpeche = jsonUserData.User?.CauseEmpeche;
        let ComprehensionBesoin = jsonUserData.User?.ComprehensionBesoin
        let ConsequencesFaits = jsonUserData.User?.ConsequencesFaits;
        let Contexte = jsonUserData.User?.Contexte;
        let ContexteContredireVerite = jsonUserData.User?.ContexteContredireVerite
        let ControleSituation = jsonUserData.User?.ControleSituation;
        let ConversationConstructive = jsonUserData.User?.ConversationConstructive;
        let DateRDV = jsonUserData.User?.Date
        let EffetSouhaiteRenvoye = jsonUserData.User?.EffetSouhaiteRenvoye;
        let Emotion = jsonUserData.User?.Emotion;
        let EmotionCause = jsonUserData.User?.EmotionCause;
        let EmotionCauseVerite = jsonUserData.User?.EmotionCauseVerite;
        let ExperimentAccompagnement = jsonUserData.User?.ExperimentAccompagnement;
        let ExperimentIntention = jsonUserData.User?.ExperimentIntention;
        let ExpressionFaits = jsonUserData.User?.ExpressionFaits;
        let FirstSimulation = jsonUserData.User?.FirstSimulation
        let PreparationDate = jsonUserData.User?.PreparationDate
        let PreparationWhen = jsonUserData.User?.PreparationWhen
        let Problematique = jsonUserData.User?.Problematique
        let Qualite = jsonUserData.User?.Qualite;
        let Qui = jsonUserData.User?.Qui;
        let RappelPreparationDate = jsonUserData.User?.RappelPreparationDate
        let Ready = jsonUserData.User?.Ready
        let RelationDifficile = jsonUserData.User?.RelationDifficile;
        let Repreparation = jsonUserData.User?.Repreparation
        let RepriseConversationEmotion = jsonUserData.User?.RepriseConversationEmotion
        let RepriseScenario = jsonUserData.User?.RepriseScenario
        let ResumeQuestion = jsonUserData.User?.ResumeQuestion
        let Role = jsonUserData.User?.Role;
        let Sensation = jsonUserData.User?.Sensation;
        let Sexe = jsonUserData.User?.Sexe;

        
      
        /*data.push({name : "Relation difficile", data:RelationDifficile})
        data.push({name : "Expérimenter maintenant mon accompagnement", data:ExperimentAccompagnement})
        data.push({name : "Date de mail de rappel", data:DateRDV})
        data.push({name : "Sexe", data:Sexe})
        data.push({name : "Avec qui", data:Qui})
        data.push({name : "Contexte", data:Contexte})
        data.push({name : "Qualité relationnelle", data:Qualite})
        data.push({name : "Sensation échelle 0-10", data:Sensation})
        data.push({name : "Emotion", data:Emotion})
        data.push({name : "Cause émotion", data:EmotionCause})
        data.push({name : "Cause émotion autre", data:EmotionCauseAutre})
        data.push({name : "Emotion qui inquiète/agace/démotive/culpabilise", data:EmotionCauseVerite})
        data.push({name : "Contrôle de la situation", data:ControleSituation})
        data.push({name : "Role", data:Role})
        data.push({name : "Effet souhaité / image renvoyée", data:EffetSouhaiteRenvoye})
        data.push({name : "Cause empeché", data:CauseEmpeche})
        data.push({name : "Action pour que la conversation se termine de façon constructive", data:ConversationConstructive})
        data.push({name : "Quelle est votre intention ?", data:Intention})
        data.push({name : "Quels sont les faits ?", data:Faits})
        data.push({name : "Quelles sont les conséquences pour moi ou pour l’équipe ?", data:Consequences})
        data.push({name : "De quoi j’ai conscience a la place de la personne ?", data:Conscience})
        data.push({name : "Qu’est-ce que je souhaiterai ?", data:Souhait})
        data.push({name : "Qu’en penses tu ?", data:Pense})
        data.push({name : "Est ce que votre formulation est ok ?", data:FormulationOK})
        data.push({name : "Relation - Prenom", data:Relation.Prenom})
        data.push({name : "Relation - Sexe", data:Relation.Sexe})
        data.push({name : "Relation - Que peut répondre la personne ?", data:Relation.Reponse})
        data.push({name : "Relation - Que peut ressentir la personne en vous écoutant ?", data:Relation.Emotion})
        data.push({name : "Relation - Que pourrait se la personne ?", data:Relation.Reaction})*/

        data.push({name : "Utilisateur", data: userId})
        data.push({name : "Société", data: Societe})
        data.push({name : "Email", data: Email})
        data.push({name : "Vivez-vous une situation relationnelle professionnelle difficile", data:RelationDifficile})
        data.push({name : "Etes-vous Ok pour expérimenter maintenant mon accompagnement ?", data:ExperimentAccompagnement})
        data.push({name : "Email de rappel pour recontacte", data:DateRDV})
        data.push({name : "Exemples de problématiques relationnelles que vous avez connues et sur lesquelles vous auriez aimé que je puisse vous accompagner ?", data:Problematique})
        data.push({name : "Masculin ou au féminin ?", data:Sexe})
        data.push({name : "Avec qui éprouvez-vous cette difficulté relationnelle ?", data:Qui})
        data.push({name : "Pouvez-vous décrire en quelques phrases le contexte à l'origine de cette difficulté ?", data:Contexte})
        data.push({name : "Comment décririez-vous votre qualité relationnelle avec votre [qui] ?", data:Qualite})
        data.push({name : "Quel est son Prénom ?", data:Relation.Prenom})
        data.push({name : "Préférez-vous qu’on utilise il ou elle pour en parler ?", data:Relation.Sexe})
        data.push({name : "Comment vous sentez vous sur une échelle de 0 à 10", data:Sensation})
        data.push({name : "Quelle serait l'émotion principale ?", data:Emotion})
        data.push({name : "Qualification de l'émotion / Quelle est la petite phrase dans votre tête qui la provoque ?", data:Relation.EmotionEngendre})
        data.push({name : "Qu’est-ce qui vous stresse ? Pourquoi vous sentez vous dans cette émotion ?", data:EmotionCause})
        data.push({name : "Est-ce que ce qui vous stresse est une vérité qui est systématiquement vraie ?", data:EmotionCauseVerite})
        data.push({name : "En réfléchissant, avez-vous souvenir d’un contexte qui contredirait cette vérité ?", data:ContexteContredireVerite})
        data.push({name : "Qu’est-ce que vous contrôlez dans cette situation ?", data:ControleSituation})
        data.push({name : "Quel est votre rôle ?", data:Role})
        data.push({name : "Quel effet souhaitez-vous produire ? Quelle image souhaitez-vous renvoyer ?", data:EffetSouhaiteRenvoye})
        data.push({name : "Comment ce qui vous met en émotion peut vous y empêcher ?", data:CauseEmpeche})
        data.push({name : "Qu’est-ce que cette personne pourrait dire ou faire pour que cet échange se termine de façon constructive ?", data:ConversationConstructive})
        data.push({name : "Est-ce votre 1ere simulation de préparation sur ce contexte ?", data:FirstSimulation})
        data.push({name : "A quelle étape souhaitez-vous reprendre le scénario de préparation ?", data:RepriseScenario})
        data.push({name : "Je vous laisse exprimer votre intention en utilisant le « Je » et le « Nous ».", data:ExperimentIntention})
        data.push({name : "Je vous laisse exprimer les faits.", data:ExpressionFaits})
        data.push({name : "A vous d’expliquer les conséquences des faits observés dans votre situation.", data:ConsequencesFaits})
        data.push({name : "Avant, souhaitez-vous reprendre notre conversation sur les émotions ?", data:RepriseConversationEmotion})
        data.push({name : "Quel est son besoin ?", data:Relation.Besoin})
        data.push({name : "Et vous quel est votre besoin dans ce contexte ?", data:Besoin})
        data.push({name : "A vous d’exprimer votre compréhension des besoins", data:ComprehensionBesoin})
        data.push({name : "Je vous laisse formuler votre question.", data:ResumeQuestion})
        data.push({name : "Je vais vous répéter ce que vous venez de formuler dans la méthodologie. Et vous allez l’écouter en vous mettant à sa place. Vous etes prêt ?", data:Ready})
        data.push({name : "Qu’en pensez-vous ? Que peut répondre [relation] ?", data:Relation.Reponse})
        data.push({name : "Que peut ressentir [relation] en vous écoutant ? Quelle serait son émotion ?", data:Relation.Emotion})
        data.push({name : "[relation] pourrait se dire quoi et agir comment ?", data:Relation.Reaction})
        data.push({name : "Est ce que vous souhaitez repréparer votre conversation ou êtes-vous ok pour l'avoir dans le réel ?", data:Repreparation})
        data.push({name : "A quel horizon souhaitez-vous qu’elle ait lieu, avant qu’elle date ?", data:PreparationDate})
        data.push({name : "Vous pouvez le faire maintenant ou lors d’une votre prochaine connexion ?", data:PreparationWhen})
        data.push({name : "A quelle échéance souhaitez-vous que je vous recontacte ?", data:RappelPreparationDate})

        let now = new Date();
        
        let ye = new Intl.DateTimeFormat('fr', { year: 'numeric' }).format(now);
        let mo = new Intl.DateTimeFormat('fr', { month: '2-digit' }).format(now);
        let da = new Intl.DateTimeFormat('fr', { day: '2-digit' }).format(now);
        let hh = new Intl.DateTimeFormat('fr', { hour: '2-digit', hour12 : false}).format(now);
        let mm = new Intl.DateTimeFormat('fr', { minute: '2-digit' }).format(now);
        let ss = new Intl.DateTimeFormat('fr', { second: '2-digit' }).format(now);
        hh = hh.replaceAll(" h", "");
        console.log(`${da}-${mo}-${ye}`);
        const csvReport : any = {
            data: data,
            headers: headers,
            filename: `AJADI-Export des données-${ye}-${mo}-${da}-${hh}${mm}${ss} - ${userIDValue}.csv`
        };
        console.log(csvReport)
        setCsvReport(csvReport);
    }
    return (
        <main className="ExportMain">
            <div className="ExportContainer">
                <button className="returnToHome" onClick={redirectHome}>Retour à l'accueil</button>
                <h1>Exportation des données vers un fichier Excel</h1>
                
                <label>
                    <span>Date de départ :</span>
                    <input type="date" onChange={handleDateUpdate} id="dateInput"/>
                </label>
                <label>
                    <span>ID de l'utilisateur :</span>
                    <input type="text" onChange={handleUserIDUpdate} id="userID" placeholder="Nom-Prenom"/>
                </label>
                <button onClick={handleExportButtonClick} className="btn btn-primary">Charger les données</button>

                <br />
                {loading && <div className="loader"></div>}
                {
                    csvReport && 
                    <CSVLink 
                    data={csvReport.data} 
                    headers={csvReport.headers} 
                    filename={csvReport.filename} 
                    separator={";"}
                    >
                        Télécharger le rapport
                    </CSVLink>

                }
            </div>
        </main>
    )
}